<template>
  <div class="app defaultContainer-component">
    <Sidebar
      :unseenChats="unseenChats"
      :notificationCount="notificationCount"
      @navToggled="navToggled($event)"
      v-if="role != 'مشتری' || $route.name !='چاپ پکینگ  لیست'"
    />
    <div class="app-body" :class="sidebarOpen ? 'main-mr' : ''" id="container">
      <main class="main mt-12" :class="role == 'مشتری' ? 'contact-main' : ''">
        <div
          class="container-fluid"
          :class="
            $router.currentRoute.path.includes('/secretariat/') ? 'pa-0' : ''
          "
        >
          <router-view v-if="allowRender"></router-view>
          <v-dialog v-model="dialog" hide-overlay persistent width="300">
            <v-card dark>
              <v-card-text class="text-center">
                کنترل دسترسی... لطفا کمی صبر کنید...
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </main>
    </div>
    <footer
      class="d-flex flex-row justify-space-between py-3"
      style="background-color: #f0f3f5 !important"
      :class="sidebarOpen ? 'main-mr' : ''"
    >
      <!--footer-->
      <div class="ml-auto">
        <a href="http://satrapp.com/" target="_blank">داشبورد مدیریتی ساتراپ</a>
        <span class="ml-1"
          >&copy; {{ enToFaDigits(moment(new Date()).format("jYYYY")) }}</span
        >
      </div>
      <div class="ml-auto">
        <span class="mr-1">محصولی از</span>
        <a href="http://sarmadbs.com/" target="_blank">خدمات تجارت سرمد</a>
      </div>
      <div class="ml-auto">
        <i class="fa fa-pencil" aria-hidden="true"></i> &nbsp;
        <span class="mr-1"
          >نسخه:
          <a href="/changelog" target="_blank">
            <span dir="ltr">{{ version }}</span>
          </a></span
        >
      </div>
    </footer>
  </div>
</template>

<script>
import nav from "@/_nav";
import moment from "moment-jalaali";
import { version } from "../../package.json";
import Axios from "axios";
import Sidebar from "./Sidebar.vue";

export default {
  name: "DefaultContainer",
  components: {
    Sidebar,
  },
  data() {
    return {
      version: "",
      nav: [],
      unseenChats: 0,
      moment: moment,
      user: "",
      role: "",
      roleType: "",
      roles: {
        Manager: "مدیر",
        ceo: "مدیرعامل",
        secretary: "منشی",
        trade: "کارشناس بازرگانی",
        tradeIntern: "کارآموز بازرگانی",
        tradeHead: "کارشناس فنی",
        queryOrganizer: "بازرس سفارشات",
        accountant: "حسابدار",
        salesManager: "مدیر فروش",
        factory: "مدیر کارخانه",
        factoryTechnical: "مسئول فنی کارخانه",
        qa: "QA & DCC",
        qc: "مدیر کنترل کیفیت و آزمایشگاه",
        qcAgent: "کنترل کیفی",
        qcDocument: "سرتیفیکیت",
        factoryPacking: "مسئول پکینگ",
        production: "مدیر خط تولید",
        delivery: "دلیوری",
        coldForgingSupervisor: "سرپرست فورج سرد",
        cuttingNutSupervisor: "مهره‌تراش",
        coatingSupervisor: "داک و پوشش",
        threadingSupervisor: "سرپرست رزوه زنی",
        machiningSupervisor: "سرپرست ماشین کاری و فرزکاری",
        cncSupervisor: "سرپرست CNC",
        knittingSupervisor: "سرپرست قلاویز زنی و مهره تراشی",
        weldingSupervisor: "سرپرست جوشکاری",
        heatTreatmentSupervisor: "سرپرست عملیات حرارتی و سیاه کاری",
        hotForgingSupervisor: "سرپرست فورج گرم",
        dichromateSupervisor: "سرپرست داکرومات",
        cuttingSupervisor: "سرپرست برشکاری",
        factoryGeneral: "کارمند کارخانه",
        warehouse: "مسئول کل انبار",
        productsWarehouse: "مسئول انبار محصولات",
        materialsWarehouse: "مسئول انبار مواد اولیه",
        toolsWarehouse: "مسئول انبار ملزومات",
        shop: "مسئول فروشگاه",
        contact: "مشتری",
      },
      factoryRoles: {
        coldForgingSupervisor: "سرپرست فورج سرد",
        cuttingNutSupervisor: "مهره‌تراش",
        coatingSupervisor: "داک و پوشش",
        threadingSupervisor: "سرپرست رزوه زنی",
        machiningSupervisor: "سرپرست ماشین کاری و فرزکاری",
        cncSupervisor: "سرپرست CNC",
        knittingSupervisor: "سرپرست قلاویز زنی و مهره تراشی",
        weldingSupervisor: "سرپرست جوشکاری",
        heatTreatmentSupervisor: "سرپرست عملیات حرارتی و سیاه کاری",
        hotForgingSupervisor: "سرپرست فورج گرم",
        dichromateSupervisor: "سرپرست داکرومات",
        cuttingSupervisor: "سرپرست برشکاری",
        factoryGeneral: "کارمند کارخانه",
      },
      roleName: "",
      allowRender: false,
      dialog: false,
      sidebarOpen: false,
      deviceType: "",
      notificationCount: 0,
    };
  },
  methods: {
    enToFaDigits(input) {
      if (input == undefined) return;
      var returnModel = "",
        symbolMap = {
          1: "۱",
          2: "۲",
          3: "۳",
          4: "۴",
          5: "۵",
          6: "۶",
          7: "۷",
          8: "۸",
          9: "۹",
          0: "۰",
        };
      input = input.toString();
      for (var i = 0; i < input.length; i++)
        if (symbolMap[input[i]]) returnModel += symbolMap[input[i]];
        else returnModel += input[i];
      return returnModel;
    },
    logout() {
      window.localStorage.clear();
      window.location.replace("/");
    },
    checkToken() {
      this.dialog = true;
      Axios.post(
        this.baseUrl + "/ppkpms/user/checkToken",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.allowRender = true;
            this.unseenChats = res.data.unseenChats;
            this.notificationCount = res.data.notificationCount;
            this.dialog = false;
            localStorage.setItem(
              "canChatExternally",
              res.data.canChatExternally
            );
          }
        })
        .catch((err) => {
          if (err.response.status == 403 || err.response.status == 404) {
            const title = (
              <div>
                <h3 class="text-center">دسترسی منقضی شده است</h3>
                <span>لطفا جهت استفاده از سامانه، دوباره ورود کنید</span>
              </div>
            );
            this.toast(title, "error");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
          }
        });
    },
    checkContactToken() {
      this.dialog = true;
      Axios.post(
        this.baseUrl + "/ppkpms/contact/checkToken",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.allowRender = true;
            this.unseenChats = res.data.unseenChats;
            this.dialog = false;
            localStorage.setItem(
              "canChatExternally",
              res.data.canChatExternally
            );
          }
        })
        .catch((err) => {
          if (err.response.status == 403 || err.response.status == 404) {
            const title = (
              <div>
                <h3 class="text-center">دسترسی منقضی شده است</h3>
                <span>لطفا جهت استفاده از سامانه، دوباره ورود کنید</span>
              </div>
            );
            this.toast(title, "error");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
          }
        });
    },
    navToggled(e) {
      this.sidebarOpen = e;
    },
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
  },

  mounted() {
    document.getElementById("container").scroll({
      top: 0,
      left: 0,
    });
    this.version = version;
    this.roleName = window.localStorage.getItem("role");

    if (
      !window.localStorage.getItem("token") ||
      !window.localStorage.getItem("role")
    ) {
      this.$router.push({
        path: "/login",
        query: { return: window.location.pathname },
      });
    } else {
      if (window.localStorage.getItem("role") == "contact") {
        this.checkContactToken();
      } else {
        this.checkToken();
      }

      // if (router.currentRoute.path == "/dashboard") {
      //   if (this.roleName == "secretary") router.push("/secretary/dashboard");
      //   else router.push("/trade/dashboard");
      // }
    }

    if (window.screen.width < 1024) {
      this.deviceType = "mobile";
    } else {
      this.deviceType = "desktop";
    }

    this.user = window.localStorage.name;
    this.nav = nav[this.roleName];
    try {
      if (this.roles[this.roleName]) {
        this.role = this.roles[this.roleName];
        if (this.factoryRoles[this.roleName]) this.roleType = "کارخانه";
        else this.roleType = "اداری";
      } else {
        this.role = "تعریف نشده";
      }
    } catch (error) {
      this.role = "تعریف نشده";
    }

    if (this.deviceType == "mobile" || this.role == "مشتری") {
      this.sidebarOpen = false;
    } else if (this.$route.name == "پکینگ  لیست جدید" || this.$route.name == "ویرایش پکینگ  لیست" || this.$route.name == "چاپ پکینگ  لیست") {
      this.sidebarOpen = false;
    } else {
      this.sidebarOpen = true;
    }
  },
};
</script>
<style lang="scss">
#container {
  transition: all 0.01s;
  overflow-y: auto;
  overflow-x: none;
}
.contact-main {
  padding: 0px 120px !important;

  @media only screen and (max-width: 1300px) {
    padding: 0px !important;
  }
}
</style>
